import { API_BASE_URL } from './apiConfig';

// Get all particulars
export const getParticulars = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/particulars`);
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch particulars');
    }
    
    return data;
  } catch (error) {
    console.error('Error fetching particulars:', error);
    throw error;
  }
};

// Get particular by ID
export const getParticular = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/particulars/${id}`);
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch particular');
    }
    
    return data;
  } catch (error) {
    console.error('Error fetching particular:', error);
    throw error;
  }
};

// Create a new particular
export const createParticular = async (particularData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/particulars`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(particularData),
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to create particular');
    }
    
    return data;
  } catch (error) {
    console.error('Error creating particular:', error);
    throw error;
  }
};

// Update a particular
export const updateParticular = async (id, particularData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/particulars/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(particularData),
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to update particular');
    }
    
    return data;
  } catch (error) {
    console.error('Error updating particular:', error);
    throw error;
  }
};

// Delete a particular
export const deleteParticular = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/particulars/${id}`, {
      method: 'DELETE',
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to delete particular');
    }
    
    return data;
  } catch (error) {
    console.error('Error deleting particular:', error);
    throw error;
  }
}; 